import http from '../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_COMMON}`

const createCity = (form = {}) => http.post(`${api}/city`, form)

export default createCity
